"use strict";

const strf = require("./string.format.js");

const UserPropertyModel = require("./models/event.userproperty.js");

/*
 *
 * Environment class
 *
 */

class MetaStreamIOUserProperties {
  constructor({ constants, logger, stored_user_properties, utility } = {}) {
    this.constant = constants;
    this.logger = logger;
    this.properties = stored_user_properties ? stored_user_properties : {};
    this.utility = utility;
  }

  reset() {
    this.properties = {};
  }

  delete({ key } = {}) {
    if (key in this.properties) {
      delete this.properties[key];
    }
    return null;
  }

  get({ key } = {}) {
    if (key in this.properties) {
      return this.properties[key];
    } else {
      return null;
    }
  }

  set({ key, value } = {}) {
    let value_type = this.utility.type_to_name(value);

    this.properties[key] = new UserPropertyModel({
      key: key,
      value_type: value_type,
      value: value,
    });

    this.logger.log(
      "userproperties",
      this.constant.MetaStreamIO_Log_UserPropertySet.format(
        key,
        JSON.stringify(value),
        value_type
      )
    );

    return this.get({ key: key });
  }

  list() {
    let properties = Object.keys(this.properties);
    let list = [];
    for (let property of properties) {
      list.push({
        key: this.properties[property].key,
        value: this.properties[property].value_type_value,
      });
    }
    return list;
  }
}

module.exports = MetaStreamIOUserProperties;
